// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnifiedDropdown_dropdownContainer__ad5lD {
    display: flex;
    width: fit-content;
    align-items: center;
    position: relative;
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    height: calc(2rem + 4px);
    box-sizing: border-box;
}

.UnifiedDropdown_dropdownContainer__ad5lD.UnifiedDropdown_fullWidth__jyusQ {
    width: 100%;
}

.UnifiedDropdown_dropdownContainer__ad5lD.UnifiedDropdown_bottomShadow__ddO7M {
    box-shadow: 0 2px 0 var(--color-lightui-surface-3);
    border-radius: 4px;
}

.UnifiedDropdown_dropdownButton__pwp-b {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 1px 8px;
    box-sizing: border-box;
    cursor: pointer;
}

.UnifiedDropdown_dropdownButton__pwp-b > *:first-child {
    flex: 1;
}

.UnifiedDropdown_hideTextOverflow__reqP1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.UnifiedDropdown_disabled__uN1Q4 {
    color: var(--color-darkui-accent-2);
    cursor: not-allowed;
}

.UnifiedDropdown_dropdownIcon__\\+zaf9 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    line-height: 0;
    margin-left: 8px;
}

.UnifiedDropdown_resetButton__9GpxT > svg {
    margin: 0;
}



.UnifiedDropdown_dropdownMenu__R6Yw2 {
    position: absolute;
    overflow: auto;
    transition: all 0.2s ease-out;
    top: calc(100% + 1px);
    left: -1px; /* Same as border width of .dropdownContainer */
    background-color: var(--color-white);
    border-radius: 4px;
    box-shadow: 0 2px 5px var(--color-137), inset 0px 0px 0px 1px var(--color-lightui-surface-4);
    max-height: 0;

    width: fit-content;
    min-width: calc(100% + 2px);
    box-sizing: content-box;
    overflow: clip;

    --dropdown-menu-max-width: auto;
    max-width: var(--dropdown-menu-max-width);
}

.UnifiedDropdown_dropdownMenu__R6Yw2.UnifiedDropdown_open__7IAWW {
    max-height: 100vh;
}

.UnifiedDropdown_dropdownMenu__R6Yw2.UnifiedDropdown_alignWithButton__V91n\\+ {
    top: -13px;
    transition: opacity 0.1s ease-out;
    opacity: 0;
}

.UnifiedDropdown_dropdownMenu__R6Yw2.UnifiedDropdown_alignWithButton__V91n\\+.UnifiedDropdown_open__7IAWW {
    opacity: 1;
}

.UnifiedDropdown_dropdownListContainer__JWYmM {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 0;
    overflow: auto;
    --dropdown-menu-max-height: fit-content;
    max-height: var(--dropdown-menu-max-height);
}

.UnifiedDropdown_dropdownListContainer__JWYmM.UnifiedDropdown_multiselectList__xJEyX {
    padding: 12px 16px;
}

.UnifiedDropdown_dropdownListContainer__JWYmM > .UnifiedDropdown_dropdownList__O8FFP:only-child {
    padding: 5px 0;
}

.UnifiedDropdown_dropdownListContainer__JWYmM > div.UnifiedDropdown_dropdownList__O8FFP:first-child {
    margin-top: -5px;
}

.UnifiedDropdown_dropdownList__O8FFP {
    margin: 0;
    padding: 0;
    --sidePadding: 4px;
}

ul.UnifiedDropdown_dropdownList__O8FFP {
    list-style: none;
}

.UnifiedDropdown_dropdownList__O8FFP:empty {
    display: none;
}


/* Container Items */
.UnifiedDropdown_containerLabelContainer__-roMw {
    display: flex;
    color: var(--color-darkui-accent-2);
    line-height: 21px;
    height: 21px;
}

.UnifiedDropdown_containerLabel__E-bLp {
    user-select: none;
    -webkit-user-select: none;
}

.UnifiedDropdown_containerResetButton__eJOoi {
    margin-left: auto;
    align-self: start;
    /* Below is copied from PromoCard */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    opacity: 75%;
    background-color: var(--color-lightui-accent-1);
    border-radius: 50%;
}

.UnifiedDropdown_selectionPreview__wIiWp {
    color: var(--color-darkui-accent-2);
}




/* Dropdown Items */
.UnifiedDropdown_dropdownItem__RIrLB {
    padding: 0 calc(var(--sidePadding) * 2) 0;
    line-height: normal;
    height: auto;
    font-size: 14px;
    user-select: none;
    -webkit-user-select: none;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_groupHeader__5JwPM {
    padding-top: 6px;
    padding-bottom: 6px;
    height: fit-content;
}

.UnifiedDropdown_dropdownItem__RIrLB:not(.UnifiedDropdown_groupHeader__5JwPM) {
    gap: 8px;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_grouped__OofAF:first-child:not(.UnifiedDropdown_groupHeader__5JwPM):not(.UnifiedDropdown_multiselectCheckboxContainer__6cdTJ) {
    padding-top: calc(var(--sidePadding) * 2);
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_grouped__OofAF:first-child:not(.UnifiedDropdown_groupHeader__5JwPM):not(.UnifiedDropdown_multiselectCheckboxContainer__6cdTJ):not(li),
li.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_ungrouped__fLdXh:first-child {
    border-top: 1px solid var(--color-108);
}

.UnifiedDropdown_dropdownList__O8FFP:only-child > .UnifiedDropdown_dropdownItem__RIrLB:first-child:not(.UnifiedDropdown_groupHeader__5JwPM):not(.UnifiedDropdown_multiselectCheckboxContainer__6cdTJ) {
    padding-top: 0;
    border-top: none;
}

.UnifiedDropdown_dropdownItem__RIrLB:hover:not(.UnifiedDropdown_multiselect__KoGME):not(.UnifiedDropdown_groupHeader__5JwPM), .UnifiedDropdown_innerDropdownItem__GVw8M:hover {
    color: var(--color-white);
    background-color: var(--color-primary)
}

.UnifiedDropdown_dropdownItem__RIrLB:last-child:not(li):not(.UnifiedDropdown_ungrouped__fLdXh) {
    padding-bottom: calc(var(--sidePadding) * 2);
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_ungrouped__fLdXh {
    padding-left: 1px;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_ungrouped__fLdXh:first-of-type:not(:only-child) {
    padding-top: var(--sidePadding);
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_multiselect__KoGME.UnifiedDropdown_hasGroups__KBFdC {
    padding-left: calc(var(--sidePadding) * 2);
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_divider__OInB\\+ {
    border: 0;
    height: 1px;
    background-color: var(--color-lightui-surface-4);
    cursor: initial;
    margin: round(up, calc(var(--sidePadding) / 2), 1px) 0;
}


/* Standard Select */
.UnifiedDropdown_innerDropdownItem__GVw8M {
    user-select: none;
    -webkit-user-select: none;
}

.UnifiedDropdown_innerDropdownItem__GVw8M.UnifiedDropdown_select__39tNv {
    display: flex;
    padding: 1px calc(var(--sidePadding) * 2);
}

.UnifiedDropdown_innerDropdownItem__GVw8M.UnifiedDropdown_ungrouped__fLdXh:first-of-type {
    margin-top: 4px;
}

.UnifiedDropdown_innerDropdownItem__GVw8M.UnifiedDropdown_grouped__OofAF:last-of-type {
    margin-bottom: 4px;
}

.UnifiedDropdown_checkmarkContainer__f5iGA {
    display: flex;
    align-items: center;
    padding-right: 4px;
}


/* Multiselect */
.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_multiselect__KoGME {
    display: flex;
    align-items: center;
    min-height: 1.75rem;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_multiselectCheckboxContainer__6cdTJ {
    min-height: fit-content;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_clickable__-Gn3J {
    cursor: pointer;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_disabled__uN1Q4 {
    cursor: not-allowed;
}

.UnifiedDropdown_dropdownItem__RIrLB.UnifiedDropdown_multiselect__KoGME > input.UnifiedDropdown_multiselectCheckbox__7mmT2 {
    margin: 0;
    height: fit-content;
}

.UnifiedDropdown_multiselectRenderedItemContainer__I\\+DbO {
    overflow: hidden;
    text-overflow: ellipsis;
}

.UnifiedDropdown_maxSelected__svLHF {
    opacity: 0.5;
    user-select: none;
    -webkit-user-select: none;
    cursor: not-allowed !important;
}


/* Groups */
.UnifiedDropdown_groupHeader__5JwPM > span, .UnifiedDropdown_groupHeader__5JwPM > span > span {
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 20px;
    min-height: 20px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.UnifiedDropdown_groupHeader__5JwPM > span:first-of-type {
    flex: 1;
    justify-content: space-between;
}

.UnifiedDropdown_groupHeaderDisplayValue__tQ472 {
    overflow: hidden;
    text-overflow: ellipsis;
}

.UnifiedDropdown_iconContainer__KPMop {
    display: flex;
}

.UnifiedDropdown_numberSelectedDisplay__78jJn {
    background-color: var(--color-lightui-accent-1);
    border-radius: 10px;
    min-width: 20px;
    justify-content: center;
    padding: 0 3px 0;
    box-sizing: border-box;
}

.UnifiedDropdown_numberSelectedDisplay__78jJn:empty {
    display: none;
}


/* Select All */
.UnifiedDropdown_selectAllLinkContainer__VuDor {
    padding-top: 0;
}

.UnifiedDropdown_selectAllLink__xgsFa {
    cursor: pointer;
    color: var(--color-blue-dark-1);
    user-select: none;
    -webkit-user-select: none;
}

span.UnifiedDropdown_multiselect__KoGME.UnifiedDropdown_noPadding__aRwL6 {
    padding: 0;
}


/* Search */
.UnifiedDropdown_searchInput__4xjS9 {
    border: none;
    width: 100%;
    box-sizing: border-box;
}

.UnifiedDropdown_embeddedSearchInput__pPOuT {
    border: 1px solid var(--color-lightui-surface-4);
    width: 100%;
    box-sizing: border-box;
    padding: 0 2px 0 8px;
}


/* Focus */
.UnifiedDropdown_dropdownContainer__ad5lD:focus,
.UnifiedDropdown_dropdownContainer__ad5lD:focus-within,
.UnifiedDropdown_dropdownButton__pwp-b:focus, 
.UnifiedDropdown_dropdownButton__pwp-b:focus-within {
    outline: 2px solid var(--color-primary);
    outline-offset: -2px;
}


/* Util */
.UnifiedDropdown_nonInteractable__mcHPm {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
}

.UnifiedDropdown_hideEmpty__k-0AH:empty {
    display: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/UnifiedDropdown/UnifiedDropdown.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;IAChD,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;;;AAIA;IACI,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU,EAAE,+CAA+C;IAC3D,oCAAoC;IACpC,kBAAkB;IAClB,4FAA4F;IAC5F,aAAa;;IAEb,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;IACvB,cAAc;;IAEd,+BAA+B;IAC/B,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;;AAGA,oBAAoB;AACpB;IACI,aAAa;IACb,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;;;;AAKA,mBAAmB;AACnB;IACI,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gDAAgD;IAChD,eAAe;IACf,sDAAsD;AAC1D;;;AAGA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;AAClC;;;AAGA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;;AAGA,eAAe;AACf;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;;AAGA,WAAW;AACX;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,sBAAsB;IACtB,oBAAoB;AACxB;;;AAGA,UAAU;AACV;;;;IAII,uCAAuC;IACvC,oBAAoB;AACxB;;;AAGA,SAAS;AACT;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".dropdownContainer {\n    display: flex;\n    width: fit-content;\n    align-items: center;\n    position: relative;\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    height: calc(2rem + 4px);\n    box-sizing: border-box;\n}\n\n.dropdownContainer.fullWidth {\n    width: 100%;\n}\n\n.dropdownContainer.bottomShadow {\n    box-shadow: 0 2px 0 var(--color-lightui-surface-3);\n    border-radius: 4px;\n}\n\n.dropdownButton {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1px 8px;\n    box-sizing: border-box;\n    cursor: pointer;\n}\n\n.dropdownButton > *:first-child {\n    flex: 1;\n}\n\n.hideTextOverflow {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.disabled {\n    color: var(--color-darkui-accent-2);\n    cursor: not-allowed;\n}\n\n.dropdownIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    line-height: 0;\n    margin-left: 8px;\n}\n\n.resetButton > svg {\n    margin: 0;\n}\n\n\n\n.dropdownMenu {\n    position: absolute;\n    overflow: auto;\n    transition: all 0.2s ease-out;\n    top: calc(100% + 1px);\n    left: -1px; /* Same as border width of .dropdownContainer */\n    background-color: var(--color-white);\n    border-radius: 4px;\n    box-shadow: 0 2px 5px var(--color-137), inset 0px 0px 0px 1px var(--color-lightui-surface-4);\n    max-height: 0;\n\n    width: fit-content;\n    min-width: calc(100% + 2px);\n    box-sizing: content-box;\n    overflow: clip;\n\n    --dropdown-menu-max-width: auto;\n    max-width: var(--dropdown-menu-max-width);\n}\n\n.dropdownMenu.open {\n    max-height: 100vh;\n}\n\n.dropdownMenu.alignWithButton {\n    top: -13px;\n    transition: opacity 0.1s ease-out;\n    opacity: 0;\n}\n\n.dropdownMenu.alignWithButton.open {\n    opacity: 1;\n}\n\n.dropdownListContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 12px 0;\n    overflow: auto;\n    --dropdown-menu-max-height: fit-content;\n    max-height: var(--dropdown-menu-max-height);\n}\n\n.dropdownListContainer.multiselectList {\n    padding: 12px 16px;\n}\n\n.dropdownListContainer > .dropdownList:only-child {\n    padding: 5px 0;\n}\n\n.dropdownListContainer > div.dropdownList:first-child {\n    margin-top: -5px;\n}\n\n.dropdownList {\n    margin: 0;\n    padding: 0;\n    --sidePadding: 4px;\n}\n\nul.dropdownList {\n    list-style: none;\n}\n\n.dropdownList:empty {\n    display: none;\n}\n\n\n/* Container Items */\n.containerLabelContainer {\n    display: flex;\n    color: var(--color-darkui-accent-2);\n    line-height: 21px;\n    height: 21px;\n}\n\n.containerLabel {\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.containerResetButton {\n    margin-left: auto;\n    align-self: start;\n    /* Below is copied from PromoCard */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    opacity: 75%;\n    background-color: var(--color-lightui-accent-1);\n    border-radius: 50%;\n}\n\n.selectionPreview {\n    color: var(--color-darkui-accent-2);\n}\n\n\n\n\n/* Dropdown Items */\n.dropdownItem {\n    padding: 0 calc(var(--sidePadding) * 2) 0;\n    line-height: normal;\n    height: auto;\n    font-size: 14px;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.dropdownItem.groupHeader {\n    padding-top: 6px;\n    padding-bottom: 6px;\n    height: fit-content;\n}\n\n.dropdownItem:not(.groupHeader) {\n    gap: 8px;\n}\n\n.dropdownItem.grouped:first-child:not(.groupHeader):not(.multiselectCheckboxContainer) {\n    padding-top: calc(var(--sidePadding) * 2);\n}\n\n.dropdownItem.grouped:first-child:not(.groupHeader):not(.multiselectCheckboxContainer):not(li),\nli.dropdownItem.ungrouped:first-child {\n    border-top: 1px solid var(--color-108);\n}\n\n.dropdownList:only-child > .dropdownItem:first-child:not(.groupHeader):not(.multiselectCheckboxContainer) {\n    padding-top: 0;\n    border-top: none;\n}\n\n.dropdownItem:hover:not(.multiselect):not(.groupHeader), .innerDropdownItem:hover {\n    color: var(--color-white);\n    background-color: var(--color-primary)\n}\n\n.dropdownItem:last-child:not(li):not(.ungrouped) {\n    padding-bottom: calc(var(--sidePadding) * 2);\n}\n\n.dropdownItem.ungrouped {\n    padding-left: 1px;\n}\n\n.dropdownItem.ungrouped:first-of-type:not(:only-child) {\n    padding-top: var(--sidePadding);\n}\n\n.dropdownItem.multiselect.hasGroups {\n    padding-left: calc(var(--sidePadding) * 2);\n}\n\n.dropdownItem.divider {\n    border: 0;\n    height: 1px;\n    background-color: var(--color-lightui-surface-4);\n    cursor: initial;\n    margin: round(up, calc(var(--sidePadding) / 2), 1px) 0;\n}\n\n\n/* Standard Select */\n.innerDropdownItem {\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.innerDropdownItem.select {\n    display: flex;\n    padding: 1px calc(var(--sidePadding) * 2);\n}\n\n.innerDropdownItem.ungrouped:first-of-type {\n    margin-top: 4px;\n}\n\n.innerDropdownItem.grouped:last-of-type {\n    margin-bottom: 4px;\n}\n\n.checkmarkContainer {\n    display: flex;\n    align-items: center;\n    padding-right: 4px;\n}\n\n\n/* Multiselect */\n.dropdownItem.multiselect {\n    display: flex;\n    align-items: center;\n    min-height: 1.75rem;\n}\n\n.dropdownItem.multiselectCheckboxContainer {\n    min-height: fit-content;\n}\n\n.dropdownItem.clickable {\n    cursor: pointer;\n}\n\n.dropdownItem.disabled {\n    cursor: not-allowed;\n}\n\n.dropdownItem.multiselect > input.multiselectCheckbox {\n    margin: 0;\n    height: fit-content;\n}\n\n.multiselectRenderedItemContainer {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.maxSelected {\n    opacity: 0.5;\n    user-select: none;\n    -webkit-user-select: none;\n    cursor: not-allowed !important;\n}\n\n\n/* Groups */\n.groupHeader > span, .groupHeader > span > span {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    line-height: 20px;\n    min-height: 20px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.groupHeader > span:first-of-type {\n    flex: 1;\n    justify-content: space-between;\n}\n\n.groupHeaderDisplayValue {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.iconContainer {\n    display: flex;\n}\n\n.numberSelectedDisplay {\n    background-color: var(--color-lightui-accent-1);\n    border-radius: 10px;\n    min-width: 20px;\n    justify-content: center;\n    padding: 0 3px 0;\n    box-sizing: border-box;\n}\n\n.numberSelectedDisplay:empty {\n    display: none;\n}\n\n\n/* Select All */\n.selectAllLinkContainer {\n    padding-top: 0;\n}\n\n.selectAllLink {\n    cursor: pointer;\n    color: var(--color-blue-dark-1);\n    user-select: none;\n    -webkit-user-select: none;\n}\n\nspan.multiselect.noPadding {\n    padding: 0;\n}\n\n\n/* Search */\n.searchInput {\n    border: none;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.embeddedSearchInput {\n    border: 1px solid var(--color-lightui-surface-4);\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0 2px 0 8px;\n}\n\n\n/* Focus */\n.dropdownContainer:focus,\n.dropdownContainer:focus-within,\n.dropdownButton:focus, \n.dropdownButton:focus-within {\n    outline: 2px solid var(--color-primary);\n    outline-offset: -2px;\n}\n\n\n/* Util */\n.nonInteractable {\n    pointer-events: none;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.hideEmpty:empty {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `UnifiedDropdown_dropdownContainer__ad5lD`,
	"fullWidth": `UnifiedDropdown_fullWidth__jyusQ`,
	"bottomShadow": `UnifiedDropdown_bottomShadow__ddO7M`,
	"dropdownButton": `UnifiedDropdown_dropdownButton__pwp-b`,
	"hideTextOverflow": `UnifiedDropdown_hideTextOverflow__reqP1`,
	"disabled": `UnifiedDropdown_disabled__uN1Q4`,
	"dropdownIcon": `UnifiedDropdown_dropdownIcon__+zaf9`,
	"resetButton": `UnifiedDropdown_resetButton__9GpxT`,
	"dropdownMenu": `UnifiedDropdown_dropdownMenu__R6Yw2`,
	"open": `UnifiedDropdown_open__7IAWW`,
	"alignWithButton": `UnifiedDropdown_alignWithButton__V91n+`,
	"dropdownListContainer": `UnifiedDropdown_dropdownListContainer__JWYmM`,
	"multiselectList": `UnifiedDropdown_multiselectList__xJEyX`,
	"dropdownList": `UnifiedDropdown_dropdownList__O8FFP`,
	"containerLabelContainer": `UnifiedDropdown_containerLabelContainer__-roMw`,
	"containerLabel": `UnifiedDropdown_containerLabel__E-bLp`,
	"containerResetButton": `UnifiedDropdown_containerResetButton__eJOoi`,
	"selectionPreview": `UnifiedDropdown_selectionPreview__wIiWp`,
	"dropdownItem": `UnifiedDropdown_dropdownItem__RIrLB`,
	"groupHeader": `UnifiedDropdown_groupHeader__5JwPM`,
	"grouped": `UnifiedDropdown_grouped__OofAF`,
	"multiselectCheckboxContainer": `UnifiedDropdown_multiselectCheckboxContainer__6cdTJ`,
	"ungrouped": `UnifiedDropdown_ungrouped__fLdXh`,
	"multiselect": `UnifiedDropdown_multiselect__KoGME`,
	"innerDropdownItem": `UnifiedDropdown_innerDropdownItem__GVw8M`,
	"hasGroups": `UnifiedDropdown_hasGroups__KBFdC`,
	"divider": `UnifiedDropdown_divider__OInB+`,
	"select": `UnifiedDropdown_select__39tNv`,
	"checkmarkContainer": `UnifiedDropdown_checkmarkContainer__f5iGA`,
	"clickable": `UnifiedDropdown_clickable__-Gn3J`,
	"multiselectCheckbox": `UnifiedDropdown_multiselectCheckbox__7mmT2`,
	"multiselectRenderedItemContainer": `UnifiedDropdown_multiselectRenderedItemContainer__I+DbO`,
	"maxSelected": `UnifiedDropdown_maxSelected__svLHF`,
	"groupHeaderDisplayValue": `UnifiedDropdown_groupHeaderDisplayValue__tQ472`,
	"iconContainer": `UnifiedDropdown_iconContainer__KPMop`,
	"numberSelectedDisplay": `UnifiedDropdown_numberSelectedDisplay__78jJn`,
	"selectAllLinkContainer": `UnifiedDropdown_selectAllLinkContainer__VuDor`,
	"selectAllLink": `UnifiedDropdown_selectAllLink__xgsFa`,
	"noPadding": `UnifiedDropdown_noPadding__aRwL6`,
	"searchInput": `UnifiedDropdown_searchInput__4xjS9`,
	"embeddedSearchInput": `UnifiedDropdown_embeddedSearchInput__pPOuT`,
	"nonInteractable": `UnifiedDropdown_nonInteractable__mcHPm`,
	"hideEmpty": `UnifiedDropdown_hideEmpty__k-0AH`
};
export default ___CSS_LOADER_EXPORT___;
